"use strict";
var utils_1 = require('./utils');
var filterObject = require('filter-object');
var SAYT_URL = '.groupbycloud.com/api/v1/sayt/search';
var Sayt = (function () {
    function Sayt(config) {
        this.config = {
            autocomplete: {
                numSearchTerms: 5,
                numNavigations: 5
            },
            productSearch: {
                numProducts: 4
            }
        };
        this.configure(config);
    }
    Sayt.prototype.configure = function (config) {
        if (config === void 0) { config = {}; }
        Object.assign(this.config, filterObject(config, '!{autocomplete,productSearch}'));
        Object.assign(this.config.autocomplete, config.autocomplete || {});
        Object.assign(this.config.productSearch, config.productSearch || {});
    };
    Sayt.prototype.autocomplete = function (query, config, cb) {
        if (query === void 0) { query = ''; }
        var finalConfig = Object.assign({ collection: this.config.collection }, this.config.autocomplete, config);
        var response = utils_1.jsonp(this.url, {
            query: query,
            language: finalConfig.language,
            collection: finalConfig.collection,
            searchItems: finalConfig.numSearchTerms,
            navigationItems: finalConfig.numNavigations,
            alphabetize: finalConfig.sortAlphabetically,
            fuzzy: finalConfig.fuzzyMatch,
            productItems: 0
        });
        return this.callbackOrPromise(response, cb);
    };
    Sayt.prototype.productSearch = function (query, config, cb) {
        if (query === void 0) { query = ''; }
        var finalConfig = Object.assign({ collection: this.config.collection }, this.config.productSearch, config);
        var response = utils_1.jsonp(this.url, {
            query: query,
            language: finalConfig.language,
            collection: finalConfig.collection,
            area: finalConfig.area,
            refinements: finalConfig.refinements,
            productItems: finalConfig.numProducts,
            searchItems: 0,
            navigationItems: 0
        });
        return this.callbackOrPromise(response, cb);
    };
    Sayt.prototype.callbackOrPromise = function (promise, cb) {
        var response = promise;
        if (typeof cb === 'function') {
            response = promise.then(function (res) { return cb(undefined, res); })
                .catch(function (err) { return cb(err); });
        }
        return response;
    };
    Object.defineProperty(Sayt.prototype, "url", {
        get: function () {
            return (this.config.https ? 'https' : 'http') + "://" + this.config.subdomain + SAYT_URL;
        },
        enumerable: true,
        configurable: true
    });
    return Sayt;
}());
exports.Sayt = Sayt;



//////////////////
// WEBPACK FOOTER
// ./~/sayt/dist/src/core/sayt.js
// module id = 208
// module chunks = 0